<template>
  <div>
    <div class="content-header">
      <div class="left">
         <span class="title">设备屏保</span>
      </div>
      <div class="right">
        <Button type="primary" @click="$router.push({name:'screen-saver-bind'})" style="margin-right: 5px">绑定设备</Button>
        <Button type="success" @click="$router.push({name:'screen-saver-edit',params: {id: 0}})">新增方案</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data"/>
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" show-elevator show-sizer show-total/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import expand from './expand.vue'
export default {
  components: { expand },
  data () {
    return {
      columns: [
        { type: 'expand',
          width: 100,
          render: (h, data) => {
            return h(expand, { props: {
              row: data.row
            } }, '')
          } },
        { key: 'id', width: 100, title: '编号' },
        { key: 'name', width: 150, title: '方案名称' },
        { key: 'names', title: '文件', tooltip: true },
        { key: 'operator',
          title: '操作',
          width: 100,
          render: (h, data) => {
            return h('div', {}, [
              h('Button', { props: { type: 'warning', size: 'small' },
                on: { click: () => {
                  this.$router.push({ name: 'screen-saver-edit', params: { id: data.row.id } })
                } } }, '编辑')
            ])
          } }
      ],
      data: [],

      page: { p: 0, l: 10 },
      total: 0
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData () {
      let cond = JSON.parse(JSON.stringify(this.page))
      this.GetScreenSaver(cond).then(res => {
        this.data = res.data
        this.total = res.total
      })
    },
    ...mapActions(['GetScreenSaver'])
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
